const $ = jQuery

function scrollToAnchor (id, custom_offset = null, duration = 800) {
  const OFFSET = custom_offset !== null ? custom_offset : getOffset()
  $('html, body').animate({
    scrollTop: $(id).offset().top - OFFSET
  }, duration)
}

function getOffset () {
  const HEADER = document.getElementById('main_header')
  const ADMIN_BAR = document.getElementById('wpadminbar')
  let offset = HEADER ? HEADER.getBoundingClientRect().height : 100
  offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
  return offset
}

module.exports = {
  scrollToAnchor,
  getOffset
}
